export default "__VITE_ASSET__raQfE88$__"